import { render, staticRenderFns } from "./AnswerAttachmentEdit.vue?vue&type=template&id=14308fe4"
import script from "./AnswerAttachmentEdit.vue?vue&type=script&lang=js"
export * from "./AnswerAttachmentEdit.vue?vue&type=script&lang=js"
import style0 from "./AnswerAttachmentEdit.vue?vue&type=style&index=0&id=14308fe4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports